import React from 'react';
import { useSearchParams } from 'react-router-dom';
import VerificationWizard from './VerificationWizard';

function Home() {
    const [searchParams] = useSearchParams();
    const token = searchParams.get('token');

    // If token exists in URL, directly mount the verification wizard
    if (token) {
        return <VerificationWizard />;
    }

    return (
        <div className="gi-mobile-card" style={{ maxWidth: '520px', minHeight: 'auto', padding: '36px 30px', textAlign: 'center' }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px', marginBottom: '24px' }}>
                <img src="/icons/icon-192x192.png" alt="IDENNTITY" className="gi-brand-icon" style={{ width: '38px', height: '38px' }} />
                <span style={{ margin: 0, fontSize: '1.55rem', fontWeight: 800, color: 'var(--gi-text-main)', fontFamily: "'Figtree', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif", letterSpacing: '-0.025em' }}>
                    IDENNTITY<span className="gi-brand-dot">.</span>
                </span>
            </div>

            <div style={{
                width: '64px',
                height: '64px',
                borderRadius: '50%',
                backgroundColor: 'var(--gi-primary-light)',
                color: 'var(--gi-primary-hover)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '28px',
                margin: '0 auto 20px'
            }}>
                !
            </div>

            <h2 style={{ fontSize: '1.25rem', fontWeight: 700, color: 'var(--gi-text-main)', margin: '0 0 10px 0' }}>
                Invalid or Missing Link
            </h2>

            <p style={{ color: 'var(--gi-text-muted)', fontSize: '0.94rem', lineHeight: 1.6, margin: '0 0 20px 0' }}>
                This verification portal requires a secure, single-use invitation link to initiate identity verification.
            </p>

            <div style={{
                backgroundColor: 'var(--gi-surface-subtle)',
                border: '1px solid var(--gi-border)',
                borderRadius: '12px',
                padding: '18px',
                textAlign: 'left',
                marginBottom: '24px'
            }}>
                <span style={{ fontSize: '0.82rem', fontWeight: 700, color: 'var(--gi-accent-text)', textTransform: 'uppercase', letterSpacing: '0.05em', display: 'block', marginBottom: '8px' }}>
                    What should you do?
                </span>
                <ul style={{ margin: 0, paddingLeft: '20px', color: 'var(--gi-text-muted)', fontSize: '0.88rem', lineHeight: 1.5 }}>
                    <li style={{ marginBottom: '6px' }}>Check your email or SMS messages from the requesting service.</li>
                    <li style={{ marginBottom: '6px' }}>Click the official verification link provided in that message.</li>
                    <li>If the link expired or you haven't received one, contact customer support.</li>
                </ul>
            </div>

            <div style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '6px',
                fontSize: '0.78rem',
                color: 'var(--gi-text-subtle)',
                fontWeight: 500
            }}>
                <span>🔒 Protected by <a href="#" target="_blank" rel="noopener noreferrer" style={{ color: 'var(--gi-text-subtle)', textDecoration: 'underline' }}>IDENNTITY</a> Verification Engine</span>
            </div>
        </div>
    );
}

export default Home;
